import { errorIdentityOf } from "@pandas/logger";
import type { ErrorComponentProps } from "@tanstack/react-router";
import { useEffect } from "react";
import { staleChunkRecovery } from "@/lib/staleChunkRecovery";
import logger from "@/utils/logging/logger";
import { ErrorFallbackContent } from "./ErrorFallbackContent";

/** Route errors land here rather than in ErrorBoundary: the router catches them first. */
export function RouteErrorFallback({ error }: ErrorComponentProps) {
	useEffect(() => {
		if (!staleChunkRecovery.maybeRecoverChunkCrash(error)) {
			logger.error("FLOW", "Unhandled route error", errorIdentityOf(error));
		}
	}, [error]);
	return <ErrorFallbackContent />;
}
